import { useSubscription } from "@apollo/client";
import { useEffect, useState } from "react";

import AssetErrorPopup from "./AssetErrorPopup";
import { getFragmentData } from "../../graphql";
import {
  AssetErrorEventDocument,
  AssetErrorEventDataFragment,
  AssetErrorEventDataFragmentDoc,
} from "../../graphql/graphql";

interface AssetErrorPopupListProps {
  factoryId: string;
}

export default function AssetErrorPopupList({
  factoryId,
}: AssetErrorPopupListProps) {
  const subscription = useSubscription(AssetErrorEventDocument, {
    variables: { factoryId: factoryId },
  });

  const [assetErrorEvents, setAssetErrorEvents] = useState<
    AssetErrorEventDataFragment[]
  >([]);

  useEffect(() => {
    const event = getFragmentData(
      AssetErrorEventDataFragmentDoc,
      subscription.data?.assetErrorEvents,
    );
    if (event) {
      if (
        event.__typename === "AssetErrorEventNew" ||
        event.__typename === "AssetErrorEventVideosAvailable"
      ) {
        setAssetErrorEvents((prev) => [event, ...prev]);
      }
    }
  }, [subscription]);

  const handleOnClose = (
    currentAssetErrorEvent: AssetErrorEventDataFragment,
  ) => {
    if (currentAssetErrorEvent.assetError.id)
      setAssetErrorEvents((prev) =>
        prev.filter(
          (assetErrorEvent) =>
            assetErrorEvent.assetError.id !==
              currentAssetErrorEvent.assetError.id ||
            assetErrorEvent.eventType !== currentAssetErrorEvent.eventType,
        ),
      );
  };

  if (!assetErrorEvents.length) {
    return null;
  }

  return (
    <>
      {assetErrorEvents.map((assetErrorEvent) => (
        <AssetErrorPopup
          key={`${assetErrorEvent.assetError.id}-${assetErrorEvent.eventType}`}
          assetErrorEvent={assetErrorEvent}
          handleOnClose={() => {
            handleOnClose(assetErrorEvent);
          }}
        />
      ))}
    </>
  );
}
